export default "__VITE_ASSET__CesKug0n__"